import React from 'react';
import { Flex } from 'common/common-components.styled';
import { useFormContext } from 'react-hook-form';
import { useReturnStep } from './use-return-step';
import FormHook from 'components/form-hook/form-hook';
import {
  CheckboxFormContainer,
  RowFormFieldsContainer,
  StepSubtitle
} from 'components/checklist-modal/checklist-modal.styled';
import { useTheme } from 'styled-components';
import { useMediaQuery } from '@mui/material';

const ReturnStep = () => {
  const reactHookFormData = useFormContext();
  const { returnFieldsLeftSection, returnFieldsRightSection } = useReturnStep(reactHookFormData);
  const theme = useTheme();
  const isMobileWidth = useMediaQuery(`(max-width:${theme.media.tabletHorizontal})`);

  return (
    <Flex width='100%' direction='column'>
      <div>
        <StepSubtitle>Rückgabe</StepSubtitle>
      </div>

      <Flex margin='30px 0 24px'>
        <RowFormFieldsContainer breakPoint='tabletHorizontal' gap={isMobileWidth ? '0 !important' : '10px'}>
          <CheckboxFormContainer>
            <FormHook
              reactHookFormData={reactHookFormData}
              formFields={returnFieldsLeftSection}
              distanceBetweenFields='0'
            />
          </CheckboxFormContainer>

          <CheckboxFormContainer>
            <FormHook
              reactHookFormData={reactHookFormData}
              formFields={returnFieldsRightSection}
              distanceBetweenFields='0'
            />
          </CheckboxFormContainer>
        </RowFormFieldsContainer>
      </Flex>
    </Flex>
  );
};

export default ReturnStep;
